import React from 'react';
import { ClaimOverviewRow } from '../claimOverview/claimOverview';
import { store } from '../../store/store';
import applicationSettingsProjections from '../../projections/applicationSettings';
import { useAppSelector } from '../../hooks/hooks';
import { useTranslation } from 'react-i18next';

type ClaimReviewOverviewObject = {
    formattedType: string;
    claimReference: string;
    createdDate: any;
};
const PolicyHolderReviewClaimOverview = (props: {
    claimReviewOverview: ClaimReviewOverviewObject | null;
}): JSX.Element => {
    const { claimReviewOverview } = props;
    const { t } = useTranslation();
    return (
        <div>
            <ClaimOverviewRow
                leftSide={() => (
                    <div>
                        <div>{t<string>('address')}</div>
                        <div>{t<string>('street')}</div>
                        <div>{t<string>('county')}</div>
                    </div>
                )}
                rightSide={() => (
                    <>
                        <div>
                            <span>{t<string>('telephone')}: </span>
                            <strong>{t<string>('tel')}</strong>
                        </div>
                        <div>
                            <span>{t<string>('faxLabel')}: </span>
                            <strong>{t<string>('fax')}</strong>
                        </div>
                        <div>
                            <span>{t<string>('emailLabel')}: </span>
                            <strong>{t<string>('aragEmail')}</strong>
                        </div>
                    </>
                )}
            />
            <ClaimOverviewRow
                leftSide={() => (
                    <>
                        <div>
                            <span>{t<string>('policyType')}: </span>
                            <strong>
                                {claimReviewOverview?.formattedType}
                            </strong>
                        </div>
                        <div>
                            <span>{t<string>('reference')}: </span>
                            <strong>
                                {claimReviewOverview?.claimReference}
                            </strong>
                        </div>
                    </>
                )}
                rightSide={() => (
                    <>
                        <span>{t<string>('date')}: </span>
                        <strong>{claimReviewOverview?.createdDate}</strong>
                    </>
                )}
            />
            {/*<div style={{left:'20px'}}>*/}
            {/*<ClaimOverviewRow*/}
            {/*    rightSide={() => (*/}
            {/*        <div  style={{ top:'40px' }}>*/}
            {/*            <Link*/}
            {/*                variant="print"*/}
            {/*                label="Print"*/}
            {/*                onClick={() => window.print()}*/}
            {/*            />*/}
            {/*        </div>*/}

            {/*    )}*/}
            {/*    />*/}
            {/*</div>*/}
        </div>
    );
};

export default PolicyHolderReviewClaimOverview;
